module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Black.205cb02e34964052460e7baeadb38267.ttf";